<template>
  <dialog-confirm
    :text="$t('are_you_sure_you_want_to_delete_domain')"
    :is-on="true"
    :is-loading="isLoading"
    :on-cancel="onCancel"
    :on-confirm="onConfirm"
    class="advertiser-domain-delete-confirm"
  />
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    advertiser() {
      return this.$store.getters['tracking/activeAdvertiser'];
    },
  },
  methods: {
    onCancel() {
      this.$router.push({
        name: 'tracking-management-advertiser',
        params: { id: this.advertiser.id },
        query: this.$route.query,
      });
    },
    onConfirm() {
      this.isLoading = true;
      this.$store.dispatch('tracking/deleteDomain', {
        domainId: parseInt(this.$route.params.domainId),
        advertiserId: this.advertiser.id,
      })
      .then(() => {
        this.onCancel();
      })
      .catch((err) => err)
      .finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>
